// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11e-m","title":"styles_title__1k8xK"};